import { appPath } from "./app_path.ts";

const isDemoPage = document.getElementById("demo-root") || document.getElementById("demo-voice-root");

if (isDemoPage && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(appPath("/demo-service-worker.js"), { scope: appPath("/") }).catch(() => {
      // Installation remains optional when service workers are unavailable or blocked.
    });
  });
}
